<template>
  <div>
    <div id="printKLine"></div>
    <div class="k-line-chart-menu-container">
      <span style="padding-right: 10px">主图指标</span>
      <button
        v-for="type in mainTechnicalIndicatorTypes"
        :key="type"
        v-on:click="setCandleTechnicalIndicator(type)"
      >
        {{ type }}
      </button>
    </div>
  </div>
</template>

<script>
import { dispose, init } from "@/util/kLine.js";
import { getkLine } from "@/api/market";
function getTooltipOptions(
  candleShowType,
  candleShowRule,
  technicalIndicatorShowRule
) {
  return {
    candle: {
      tooltip: {
        showType: candleShowType,
        showRule: candleShowRule,
        labels: ["开盘价：", "收盘价：", "涨跌幅："],
        values: (kLineData) => {
          const change =
            ((kLineData.close - kLineData.open) / kLineData.open) * 100;
          return [
            {
              value: kLineData.open.toFixed(2),
              color: change > 0 ? "#EF5350" : "#26A69A",
            },
            {
              value: kLineData.close.toFixed(2),
              color: change > 0 ? "#EF5350" : "#26A69A",
            },
            {
              value: `${change.toFixed(2)}%`,
              color: change > 0 ? "#EF5350" : "#26A69A",
            },
          ];
        },
      },
    },
    technicalIndicator: {
      tooltip: {
        showRule: technicalIndicatorShowRule,
      },
    },
  };
}
export default {
  props: ["minute"],
  data() {
    return {
      kLineData: {},
      mainTechnicalIndicatorTypes: ["MA", "EMA", "SAR"],
      subTechnicalIndicatorTypes: ["VOL", "MACD", "KDJ"],
      tableData: [],
      candleShowType: "standard",
      candleShowRule: "follow_cross",
      technicalIndicatorShowRule: "always",
    };
  },
  created() {
    console.log("加载完成");
  },

  mounted() {
    console.info("1111111");
    const id = this.$route.query.id;
    getkLine({ id, minute: this.minute }).then((res) => {
      console.info(res);
      let result = res.data.data.klineData;
      console.info("记录数: ", result.length);
      let timeList = res.data.data.klineDate;

      result.map((item, index) => {
        let obj = {};
        obj.close = item[1];
        obj.high = item[3];
        obj.low = item[2];
        obj.open = item[0];
        let time = timeList[index];
        time = time.replace(new RegExp("-", "gm"), "/");
        obj.timestamp = new Date(time).getTime();

        this.tableData.push(obj);
      });
      this.kLineChart = init("printKLine", {
        candle: {
          margin: {
            top: 0.2,
            bottom: 0.2,
          },
          bar: {
            upColor: "#F92855",
            downColor: "#2DC08E",
          },
          priceMark: {
            last: {
              upColor: "#F92855",
              downColor: "#2DC08E",
            },
          },
        },
        xAxis: {
          show: true,
          size: "auto",
          // x轴线
          axisLine: {
            show: true,
            // color: "#888888",
            size: 1,
          },

          // x轴分割线
          tickLine: {
            show: true,
            size: 1,
            length: 3,
            // color: "#888888",
          },
        },
        yAxis: {
          type: "normal",
          position: "right",
          axisLine: {
            show: true,
            color: "#888888",
            size: 2,
          },
        },
      });
      this.kLineChart.applyNewData(this.tableData);
      this.kLineChart.createTechnicalIndicator("MA", false, {
        id: "candle_pane",
      });
      this.kLineChart.overrideTechnicalIndicator(
        {
          name: "MA",
          shortName: "",
          visible: "none",
          calcParams: [5, 10, 20],
        },
        "candle_pane"
      );
      this.setCandleShowRule();
      const dom = document.querySelector("canvas");
      dom.style.width = "400px";
      console.log(dom, "dom");
    });
  },
  destroyed: function () {
    dispose("printKLine");
  },
  methods: {
    setCandleTechnicalIndicator: function (type) {
      this.kLineChart.createTechnicalIndicator(type, false, {
        id: "candle_pane",
      });
    },
    setCandleShowRule() {
      this.candleShowRule = "follow_cross";
      this.kLineChart.setStyleOptions(
        getTooltipOptions(
          this.candleShowType,
          this.candleShowRule,
          this.technicalIndicatorShowRule
        )
      );
    },
  },
};
</script>

<style lang="less" scoped>
#printKLine {
  width: 700px;
  height: 500px;
  // margin: 0 auto;
  margin-left: 20px;
}
body {
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f2f3f5;
}

div,
p {
  box-sizing: border-box;
}

p {
  margin: 0;
}

.app {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  padding: 15px;
}
.k-line-chart-container {
  display: flex;
  flex-direction: column;
  margin: 15px;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  background-color: #ffffff;
  width: 620px;
  height: 440px;
  padding: 16px 6px 16px 16px;
}

.k-line-chart-title {
  margin: 0;
  color: #252525;
  padding-bottom: 10px;
}

.k-line-chart {
  display: flex;
  flex: 1;
}
.k-line-chart-menu-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  font-size: 12px;
  color: #606060;
  justify-content: center;
}
.k-line-chart-menu-container button {
  cursor: pointer;
  background-color: #2196f3;
  border-radius: 2px;
  margin-right: 8px;
  height: 24px;
  line-height: 26px;
  padding: 0 6px;
  font-size: 12px;
  color: #fff;
  border: none;
  outline: none;
}
</style>
